import React, { useState, useEffect, useRef } from "react";
import api from "../../api";
import styles from "./TaskQnA.module.css";

export default function TaskQnA({ taskId, currentUserId, onChatClosed }) {
  const [comments, setComments] = useState([]);
  const [text, setText]         = useState("");
  const [loading, setLoading]   = useState(true);
  const [closed, setClosed]     = useState(false);
  const bottomRef               = useRef(null);

  const load = () => {
    api.get(`/tasks/${taskId}/comments/`)
      .then(res => setComments(res.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [taskId]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [comments]);

  const submit = async () => {
    const content = text.trim();
    if (!content) return;
    await api.post(`/tasks/${taskId}/comments/`, { content });
    setText("");
    load();
  };

  const handleChatClose = async () => {
    if (!window.confirm("대화를 종료하시겠습니까? 종료 후에는 이 업무가 목록에서 사라집니다.")) return;
    await api.patch(`/tasks/${taskId}/chat-close/`);
    setClosed(true);
    if (onChatClosed) onChatClosed(taskId);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  if (loading) return <div className={styles.loading}>불러오는 중...</div>;

  return (
    <div className={styles.wrap}>

    <div className={styles.header}>💬 대화</div>


      <div className={styles.chatBox}>
        {comments.length === 0 && (
          <div className={styles.empty}>아직 대화가 없습니다.</div>
        )}
        {comments.map(c => {
          const isMine = c.author === currentUserId;
          return (
            <div key={c.id} className={`${styles.row} ${isMine ? styles.rowMine : styles.rowOther}`}>
              {!isMine && (
                <div className={styles.avatar}>
                  {c.author_name?.slice(0, 1)}
                </div>
              )}
              <div className={styles.bubble_wrap}>
                {!isMine && <div className={styles.name}>{c.author_name}</div>}
                <div className={`${styles.bubble} ${isMine ? styles.bubbleMine : styles.bubbleOther}`}>
                  {c.content}
                </div>
                <div className={`${styles.time} ${isMine ? styles.timeRight : ""}`}>
                  {c.created_at?.slice(0, 16).replace("T", " ")}
                </div>
              </div>
              {isMine && (
                <div className={styles.avatar}>
                  {c.author_name?.slice(0, 1)}
                </div>
              )}
            </div>
          );
        })}
        <div ref={bottomRef} />
      </div>

      <div className={styles.inputRow}>
        <textarea
          className={styles.textarea}
          placeholder="메시지를 입력하세요... (Enter 전송, Shift+Enter 줄바꿈)"
          value={text}
          onChange={e => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          rows={2}
        />
        <div style={{display:"flex", flexDirection:"column", gap:6}}>
          <button className={styles.btnSend} onClick={submit}>전송</button>
          {!closed ? (
            <button
              onClick={handleChatClose}
              style={{
                fontSize:11, padding:"6px 0", borderRadius:8,
                border:"1px solid #ffcccc", background:"#fff5f5",
                color:"#cc0000", cursor:"pointer", fontWeight:600,
                width:60,
              }}
            >
              종료
            </button>
          ) : (
            <span style={{fontSize:10, color:"#aaa", textAlign:"center"}}>종료됨</span>
          )}
        </div>
      </div>


    </div>
  );
}